export default "__VITE_ASSET__BRwpK1GL__"